export default "__VITE_ASSET__B141btAV__"